<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates11">
<p class="centerImage"><img alt="images" id="plate11" src="images/plate11.jpg"/></p>
<p class="caption">Croydon 1940, left to right: Derek Ford, Ricky Wright, RWF and Peter Thompson. <em class="italic">(Wright family)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates11.vue?59d2e4d6